import { h } from '../utils/dom.ts';
import { t } from '../i18n/index.ts';
import { emptyState, loadInto, skeleton } from '../components/ui.ts';
import { platformShell } from '../components/layout.ts';
import { heroArt } from '../components/illustrations.ts';
import { poleBand } from '../components/shop-hero.ts';
import type { TenantSummary } from '../services/tenant.ts';
import { listTenants } from '../services/public-api.ts';
import { errorMessageKey } from '../services/errors.ts';

/** Platform landing page: what termin.quest is, and the list of shops. */
export function homePage(): HTMLElement {
  const list = h('div');
  void loadInto(list, listTenants, (tenants: TenantSummary[]) =>
    tenants.length === 0
      ? emptyState(t('home.empty'))
      : h('ul', { class: 'tenant-list' }, tenants.map((tn) => {
          const icon = h('img', { src: `/tenants/${tn.slug}/icon-192.png`, alt: '', width: 52, height: 52, loading: 'lazy' });
          icon.addEventListener('error', () => icon.remove(), { once: true });
          return h('li', null, h('a', { href: `/s/${tn.slug}/`, class: 'card tenant-card', 'data-link': true },
            icon,
            h('div', null, h('strong', null, tn.name), h('span', { class: 'muted' }, tn.city)),
            h('span', { class: 'go' }, `${t('home.book')} →`),
          ));
        })),
    skeleton(2), errorMessageKey);

  return platformShell(h('div', { class: 'page' },
    h('section', { class: 'hero home-hero' },
      h('div', { class: 'hero-pattern', 'aria-hidden': 'true' }),
      h('div', { class: 'hero-body' },
        h('p', { class: 'hero-kicker' }, 'termin.quest'),
        h('h1', { class: 'hero-title' }, t('home.heroTitle')),
        h('p', null, t('home.heroText')),
      ),
      h('div', { class: 'hero-art-wrap', 'aria-hidden': 'true' }, heroArt()),
    ),
    poleBand(),
    h('h2', { class: 'step-title' }, t('home.title')),
    list,
  ));
}

export function notFoundPage(messageKey: 'error.notFound' | 'error.tenantNotFound' = 'error.notFound'): HTMLElement {
  return h('div', { class: 'shell' },
    h('main', { class: 'content page center' },
      h('h1', null, '404'),
      h('p', null, t(messageKey)),
      h('a', { href: '/', class: 'btn btn-primary', 'data-link': true }, t('error.back')),
    ),
  );
}
